module.exports = {
      id: "icon-italic-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-italic",
      toString: function () {
        return this.url;
      }
    }